import { Directive, ElementRef, Input, Output, HostListener, Renderer2 } from '@angular/core';
import { PagingRequest } from '../../../models/common/paging';

@Directive({ selector: '[sort]' })
export class SortPropertyDirective {
    private descending: boolean = null;
    private iconElement: any;

    constructor(private elementRef: ElementRef, private renderer: Renderer2) {
        this.iconElement = this.renderer.createElement(this.elementRef.nativeElement, 'i');

        this.iconElement.style.marginRight = '5px';
        this.iconElement.className = 'fa fa-arrows-v';
    }
    
    @Input('sort') request: PagingRequest;
    @Input('title') title: string;

    @Output()
    
    private setIcon() {
        //Set others to no longer have arrow
        jQuery(this.elementRef.nativeElement).siblings().children('i').each((index, element) => {
            const $iElement = jQuery(element);
            
            $iElement.css('margin-right', 0);
            $iElement.removeClass();
        });
        
        this.iconElement.style.marginRight = '5px';

        if (this.descending) {
            this.iconElement.className = 'fa fa-arrow-down';
        } else {
            this.iconElement.className = 'fa fa-arrow-up';
        }
    }

    @HostListener('click')
    sortBy() {
        this.descending = this.descending === null ? false : !this.descending;

        this.setIcon();

        this.request.sortProperty = this.title;
        this.request.descending = this.descending;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/components/common/search/sort.property.directive.ts